import API from "./axios";

const expensePaymentApi = {
  paged:   (params)   => API.get("/expense-payments/paged", { params }),
  getById: (id)       => API.get(`/expense-payments/${id}`),
  total:   (params)   => API.get("/expense-payments/total", { params }),
  create:  (data)     => API.post("/expense-payments", data),
  update:  (id, data) => API.put(`/expense-payments/${id}`, data),
  cancel:  (id)       => API.patch(`/expense-payments/${id}/cancel`),
  delete:  (id)       => API.delete(`/expense-payments/${id}`),
};

export default expensePaymentApi;